import classNames from "classnames"
import React from "react"

export const COMPONENT_KIND_CLASS_MAP = {
  delete: "tds-btn--delete",
  ghost: "tds-btn--ghost-neutral",
  "ghost-delete": "tds-btn--ghost-delete",
  "ghost-interaction": "tds-btn--ghost-interaction",
  "inline-text": "tds-btn--inline-text",
  neutral: "tds-btn--neutral",
  "neutral-inline": "tds-btn--neutral-inline",
  pill: "tds-btn--pill",
  primary: "tds-btn--interaction",
  "primary-page-header": "tds-btn--primary-page-header",
  secondary: "tds-btn--outline-neutral",
  "secondary-delete": "tds-btn--outline-delete",
  "secondary-interaction": "tds-btn--outline-interaction",
  "secondary-page-header": "tds-btn--secondary-page-header",
  "staff-only": "tds-btn--staff-only",
} as const

export const COMPONENT_SIZE_CLASS_MAP = {
  lg: "tds-btn--lg",
  md: "",
  sm: "tds-btn--sm",
  xl: "tds-btn--xl",
  xs: "tds-btn--xs",
} as const

export type ComponentSize = keyof typeof COMPONENT_SIZE_CLASS_MAP

export type ComponentKind = keyof typeof COMPONENT_KIND_CLASS_MAP

export interface BaseComponentProps {
  /** Whether the component should take the full width of its container. */
  fullWidth?: boolean
  /** The visual style of the component. */
  kind?: ComponentKind
  /** A React node to display before the component's content. Set via story args for non-primitive values. */
  prefix?: React.ReactNode
  /** The size of the component. */
  size?: ComponentSize
  /** A React node to display after the component's content. Set via story args for non-primitive values. */
  suffix?: React.ReactNode
}

export const enhanceElementWithClassName = (
  element: React.ReactNode,
  className: string
): React.ReactNode => {
  if (!element) return null

  if (React.isValidElement(element)) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return React.cloneElement(element as React.ReactElement<any>, {
      className: classNames(
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (element as React.ReactElement<any>).props.className,
        className
      ),
    })
  }

  if (typeof element === "string" && element.trim()) {
    return React.createElement("span", { className }, element)
  }

  return null
}
